<!-- 运维视图: 交接工具 -->
<template>
  <el-card class="box-card">
    <div slot="header" class="clearfix">
      <span>交接工具</span>
      <el-button v-if="saveBtnExisted" @click="save" style="float: right; padding: 3px 0;" type="text">
                <span>
                    <i class="el-icon-files">
                    </i>
                    保存
                </span>
      </el-button>
      <el-button v-if="confirmHandoverToolsBtnExisted" @click="confirmHandoverTools"
                 style="float: right; padding: 3px 0;" type="text">
        <i class="el-icon-circle-check">
        </i>工具确认
      </el-button>
      <span v-if="handoverToolsConfirmIconExisted" style="float: right; padding: 3px 0;">
                <i class="el-icon-circle-check">
                </i>工具已确认
            </span>
    </div>
    <div style="height:300px;overflow-y:scroll;" v-loading="loading">
      <el-row>
        <el-col :key="tool.value" v-for="tool in tools" :xl="24" :lg="24" :md="24" :sm="24" :xs="24">
          <el-row>
            <el-col :xl="24" :lg="24" :md="24" :sm="24" :xs="24">
              <el-row>
                <el-col :xl="24" :lg="24" :md="24" :sm="24" :xs="24" style="padding-right:10px;padding-top:5px;">
                  {{ tool.description }}
                  <span v-if="tool.unit !== undefined && tool.unit !== null">
                                        ({{ tool.unit }})
                                    </span>
                </el-col>
              </el-row>
            </el-col>
            <el-col :xl="24" :lg="24" :md="24" :sm="24" :xs="24">
              <el-row>
                <el-col :span="6">
                  <el-input type="number" min="0" v-model="tool.data" :disabled="!editable" placeholder="数字"
                            @focus="handleFocus" @blur="handleBlur"
                            size="small">
                  </el-input>
                </el-col>
                <el-col :span="12" style="padding-left: 10px;">
                  <el-input v-model="tool.remark" :disabled="!editable" placeholder="备注"
                            @focus="handleFocus" @blur="handleBlur"
                            size="small">
                  </el-input>
                </el-col>
                <el-col :span="6">
                                    <span v-if="tool.standard != null" class="font-12 tipword"
                                          style="margin-top: 5px;color:#409EFF;">
                                        标准：{{ tool.standard }}
                                    </span>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </div>
  </el-card>
</template>

<script>
import _ from 'lodash';
import DutyServer from '@/api/duty';

export default {
  name: "operation-board-handover-tool",
  props: {
    departmentId: {},
    logbook: {},
  },
  data() {
    return {
      /*[{
          "value": "KEY",
          "description": "钥匙",
          "data": "",
          "unit": "",
          "standard": "",
          "remark": ""
      }]*/
      tools: [],

      oldTools: [],
      focusCount: 0,

      loading: false,
    };
  },
  computed: {
    editable() {
      let logbook = this.logbook;
      return logbook != null && logbook.status === 'DRAFT';
    },
    saveBtnExisted() {
      let logbook = this.logbook;
      return logbook != null && logbook.status === 'DRAFT';
    },
    confirmHandoverToolsBtnExisted() {
      let logbook = this.logbook;
      return logbook != null && logbook.status === 'HANDLED' && !logbook.handoverToolsConfirm;
    },
    handoverToolsConfirmIconExisted() {
      let logbook = this.logbook;
      return logbook != null && logbook.handoverToolsConfirm;
    },
    loadToolsTrigger() {
      let departmentId = this.departmentId;
      let logbook = this.logbook;
      return {
        departmentId: departmentId,
        logbookId: logbook == null ? null : logbook.logbookId,
      };
    },
  },
  watch: {
    loadToolsTrigger: {
      immediate: true,
      deep: true,
      handler() {
        this.query();
      },
    },
  },
  methods: {
    async loadTools() {
      let departmentId = this.departmentId;
      let logbook = this.logbook;
      let tools = [];
      let response;
      if (departmentId == null) {
        tools = [];
      } else {
        if (logbook == null) {
          response = await DutyServer.handoverTools.getDefaultHandoverTools(departmentId);
        } else if (logbook.status === 'DRAFT') {
          response = await DutyServer.handoverTools.getMergedHandoverToolsByLogbookId(logbook.logbookId,
              {addNewConfig: true, overrideByNewConfig: true, clearRemark: false});
        } else {
          response = await DutyServer.handoverTools.getLogbookHandoverToolsByLogbookId(logbook.logbookId);
        }
        if (response.status === 200 && response.data.code === 200) {
          tools = response.data.result;
        } else {
          this.$message.error(response.data.message);
        }
      }
      this.tools = tools;
      this.oldTools = JSON.parse(JSON.stringify(this.tools));
    },
    query() {
      this.loading = true;
      this.loadTools().finally(() => {
        this.loading = false;
      });
    },
    async save() {
      let logbook = this.logbook;
      let handoverTools = this.tools;
      if (logbook != null) {
        let logbookId = this.logbook.logbookId;
        let response = await DutyServer.logbook.updateHandoverTools(logbookId, handoverTools);
        if (response.status === 200 && response.data.code === 200) {
          this.$message.success('保存成功');
          this.query();
        } else {
          this.$message.error(response.data.message);
        }
      }
      return Promise.resolve(handoverTools);
    },
    async confirmHandoverTools() {
      let logbook = this.logbook;
      if (logbook != null) {
        let logbookId = this.logbook.logbookId;
        let response = await DutyServer.logbook.confirmHandoverTools(logbookId);
        if (response.status === 200 && response.data.code === 200) {
          this.$message.success('确认成功!');
          this.$emit('after-confirm', true);
        } else {
          this.$message.error(response.data.message);
        }
      }
      return Promise.resolve();
    },
    handleFocus() {
      this.focusCount++;
    },
    handleBlur() {
      this.focusCount--;
      if (this.focusCount <= 0) {
        setTimeout(() => {
          if (this.focusCount <= 0) {
            this.checkSave();
          }
        }, 10);
      }
    },
    checkSave() {
      let changed = false;
      let tools = this.tools, oldTools = this.oldTools;
      if (tools.length !== oldTools.length) {
        changed = true;
      } else {
        let oldToolsMap = _.keyBy(oldTools, 'value');
        for (let i = 0, len = tools.length; i < len; i++) {
          let tool = tools[i];
          let oldTool = oldToolsMap[tool.value];
          if (oldTool == null) {
            changed = true;
          } else {
            for (let key in tool) {
              if (tool.hasOwnProperty(key) && String(tool[key]) !== String(oldTool[key])) {
                changed = true;
              }
            }
          }
        }
      }
      if (changed) {
        this.$confirm('交接工具已修改，确定保存吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.save();
        }, () => {
          // this.tools = JSON.parse(JSON.stringify(this.oldTools));
        });
      }
    },
  },
}
</script>

<style scoped>

</style>
